/**
 * Shared thresholds for plan-limit meters, so the API/MCP usage bars turn amber and
 * red at the same points as the billing page's.
 */
export const limitStatus = (current: number, limit: number) => {
    let [full, nearLimit] = [false, false];

    // `>=` (not `===`) so an over-quota state (current > limit, e.g. after a
    // downgrade) is still flagged as full instead of silently rendering a
    // negative "remaining".
    if (current >= limit) {
        full = true;
    }

    if (current >= limit * 0.7 && !full) {
        nearLimit = true;
    }

    return {
        nearLimit,
        full,
    };
};
